import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { useTranslation } from 'react-i18next';

import styles from './SortableAttachment.module.scss';
import { Props } from './SortableAttachment.types';

/** One thumbnail of FormAttachmentViewer, made draggable to change the order. */
const SortableAttachment = ({ id, children, className }: Props) => {
  const { t } = useTranslation();
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
  });

  return (
    <div
      ref={setNodeRef}
      className={`${className ?? ''} ${styles.container} ${isDragging ? styles.dragging : ''}`}
      style={{ transform: CSS.Transform.toString(transform), transition }}
      {...attributes}
      {...listeners}
      aria-label={t('formAttachmentViewer.dragHint', 'Glisser pour changer l’ordre')}
    >
      {children}
    </div>
  );
};

export default SortableAttachment;
